import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      activeLoader: 'loader/activeLoader',
    }),
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from === undefined || from.name === 'SignIn' || from.path === '/') {
        vm.activeLoader();
      }
    });
  },
};
